// extracted by mini-css-extract-plugin
export default {"container":"Kiosk_container__B+FPW","kioskContainer":"Kiosk_kioskContainer__tOnHT"};